import { CSSProgressiveHeading01 } from "@caisy/league";
import styled from "styled-components";

export const SCreateProjectModalContentTitle = styled.div`
  ${CSSProgressiveHeading01};
  color: #000;
  margin-bottom: 24px;
`;
